import { useMemo } from 'react';
import { IAdditionalVariantsQuotes } from '../model/IFinanceQuote';

export const useMultipleFinanceQuote = (financeQuotes: IAdditionalVariantsQuotes, variantId: string) => {
  const isMultipleQuoteVariant = useMemo(() => {
    const financeQuotesVariantsIds = Object.keys(financeQuotes ?? []).map(key => key.toLowerCase());

    return financeQuotesVariantsIds.includes(variantId.toLowerCase());
  }, [financeQuotes, variantId]);

  return { isMultipleQuoteVariant };
};
